<template>
    <div class="container bng-slots bng-narrow-container">
            <game-banner />
            <jackpots-bar v-if="jackpots && jackpots.length"/>
            <slots-filter
                :on-filter="(slotCategory, sort, searchText) => filter(slotCategory, sort, searchText)"
            />
            <game-list v-if="games" :games="games" />
    </div>
</template>
<script>
import Vue from 'vue';

import SlotsFilter from '../../../common/slots-filter/slots-filter.vue';
import GameList from '../../../common/game-list/game-list.vue';
import JackpotsBar from '../../../common/jackpots/jackpots-bar/jackpots-bar.vue';
import GameBanner from '../../../common/banners/game-banners/game-banner.vue';

export default {
    name: 'slots',
    components: { SlotsFilter, GameList, JackpotsBar, GameBanner },
    data() {
        return {
            games: null,
            slots: {
                all: [],
                new: [],
                popular: [],
                nonslot: []
            },
            theme: null
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        player() {
            return Vue.state.player.get();
        },
        jackpots() {
            return (
                (this.player &&
                    this.player.balance &&
                    this.player.activeJackpots) ||
                []
            );
        }
    },
    created() {
        let games = Vue.state.games.get().categories.find(c => c.name == 'slots').games;
        games.forEach(s => {
            this.slots.all.push(s);
            if (s.isNew) this.slots.new.push(s);
            if (s.isPopular) this.slots.popular.push(s);
            if (s.subCategory !== 'slot') this.slots.nonslot.push(s);
        });
        this.games = this.slots.all;
        this.filter('all', 'popularity', null);
        this.theme = (this.client && this.client.view && this.client.view.style.theme) || 'dark';
    },
    methods: {
        filter(slotCategory, sort, searchText) {
            if (sort === 'alphabetically') {
                this.slots[slotCategory].sort((a, b) => a.gameId.localeCompare(b.gameId));
            } else if (sort === 'popularity') {
                this.slots[slotCategory].sort((a, b) => {
                    return b.priority - a.priority;
                });
            }
            this.games = searchText ? this.slots[slotCategory].filter(s => s.gameId.indexOf(searchText) > -1) : this.slots[slotCategory];
        }
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/slots/slots.vue